function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1.75006 7.99991C1.75006 7.99991 4.75006 1.99991 10.0001 1.99991C15.2501 1.99991 18.2501 7.99991 18.2501 7.99991C18.2501 7.99991 17.8198 9.43072 17 10.5C13 9.5 12.5 10 11 10.5C9.89865 10.5 8.5 12 7 13.3186C3.6234 11.7466 1.75006 7.99991 1.75006 7.99991Z",
  stroke: "#86ACD2",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.0001 10.2499C11.2427 10.2499 12.2501 9.24252 12.2501 7.99988C12.2501 6.75724 11.2427 5.74988 10.0001 5.74988C8.75742 5.74988 7.75006 6.75724 7.75006 7.99988C7.75006 9.24252 8.75742 10.2499 10.0001 10.2499Z",
  stroke: "#86ACD2",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M5.75006 15.9999C5.75006 15.9999 8.75006 9.99988 14.0001 9.99988C19.2501 9.99988 22.2501 15.9999 22.2501 15.9999C22.2501 15.9999 19.2501 21.9999 14.0001 21.9999C8.75006 21.9999 5.75006 15.9999 5.75006 15.9999Z",
  stroke: "#86ACD2",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M14.0001 18.2499C15.2427 18.2499 16.2501 17.2425 16.2501 15.9999C16.2501 14.7572 15.2427 13.7499 14.0001 13.7499C12.7574 13.7499 11.7501 14.7572 11.7501 15.9999C11.7501 17.2425 12.7574 18.2499 14.0001 18.2499Z",
  stroke: "#86ACD2",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
const SvgDoubleEyeClosed = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3, _ref4);
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDoubleEyeClosed, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/double-eye-closed.1fcc6cf0.svg";
export { ForwardRef as ReactComponent };